import { useState } from "react";
import { Check, Copy, Sparkles } from "lucide-react";

export default function EmbedBadgeSection() {
  const [copied, setCopied] = useState(false);

  const snippet = `[![Built on Anter AI](https://anter.ai/badges/powered-by-anter.svg)](https://anter.ai?utm_source=embed_badge)`;

  const copySnippet = () => {
    navigator.clipboard.writeText(snippet);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="mt-20 rounded-3xl border border-primary-border/60 bg-bg-secondary/60 p-8 md:p-12 backdrop-blur-md shadow-xl">
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="max-w-xl text-left">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-3 py-1 text-xs font-semibold text-primary-text mb-4">
            <Sparkles className="h-3.5 w-3.5" aria-hidden="true" />
            Developer Badge
          </div>
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-text">
            Add "Built on Anter" to Your Repo
          </h2>
          <p className="mt-3 text-sm text-text-muted leading-relaxed">
            Running your AI agents on Anter? Showcase your integration on GitHub, documentation
            sites, or blog posts with our official badge.
          </p>
        </div>

        <div className="w-full md:w-auto flex flex-col items-center md:items-end gap-4">
          <div className="rounded-xl border border-neutral-800 bg-neutral-950 p-4 flex items-center justify-center">
            <img
              src="/badges/powered-by-anter.svg"
              alt="Built on Anter AI badge"
              width="160"
              height="28"
              loading="lazy"
            />
          </div>

          <button
            type="button"
            onClick={copySnippet}
            aria-live="polite"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-primary bg-primary px-5 py-2.5 text-xs font-semibold text-primary-text-strong shadow-md transition hover:opacity-90 cursor-pointer w-full sm:w-auto"
          >
            {copied ? (
              <Check className="h-4 w-4" />
            ) : (
              <Copy className="h-4 w-4 text-primary-text-strong" />
            )}
            {copied ? "Copied Markdown!" : "Copy Badge Markdown"}
          </button>
        </div>
      </div>
    </section>
  );
}
